import React, { FC } from "react";
import { Typography } from "@mui/material";
import { ChatSupportIcon } from "../Icons";
import { ProgressBar } from "../ProgressBar/ProgressBar";

interface SupportModalHeaderProps {
  heading: string;
  description: string;
  filledSegments?: number;
  whiteSpacePreLine?: boolean;
}

const SupportModalHeader: FC<SupportModalHeaderProps> = ({
  heading,
  description,
  filledSegments,
  whiteSpacePreLine,
}) => (
  <div className="flex flex-col gap-4 items-center px-6 w-full shrink-0">
    <div className="flex flex-col gap-2 items-center px-6 w-full">
      <div className="flex items-center justify-center rounded-full bg-taupe-4 w-[52px] h-[52px]">
        <ChatSupportIcon width={32} height={32} />
      </div>
      <div className="flex flex-col gap-1 items-center text-center w-full">
        <Typography
          className="grenette-pro"
          sx={{
            fontSize: "24px",
            lineHeight: "28px",
            fontWeight: 600,
            ...(whiteSpacePreLine && { whiteSpace: "pre-line" }),
          }}
        >
          {heading}
        </Typography>
        <Typography sx={{ fontSize: "14px", lineHeight: "20px", color: "black.main" }}>
          {description}
        </Typography>
      </div>
    </div>

    {filledSegments !== undefined && (
      <div className="w-full">
        <ProgressBar
          totalSegments={2}
          filledSegments={filledSegments}
          halfSegmentIndex={null}
          unfilledClassName="bg-taupe-50"
        />
      </div>
    )}
  </div>
);

export default SupportModalHeader;
